// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ExtErrors$SmartcutsMacros = require("../../../ExtErrors.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../../../bs-utils/src/DeccoUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../../../DOM__Element.bs.js");
var StateMachine$SmartcutsMacros = require("../../../StateMachine.bs.js");
var PlaybackOptions$SmartcutsMacros = require("../../../PlaybackOptions.bs.js");
var SelectionSemantics$SmartcutsMacros = require("../../../SelectionSemantics/SelectionSemantics.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../../../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var CommandPreconditions$SmartcutsMacros = require("../../../CommandPreconditions.bs.js");
var CommandPlaybackRuntime$SmartcutsMacros = require("../../../CommandPlaybackRuntime.bs.js");
var ExtErrors__OverlayBlocking$SmartcutsMacros = require("../../../ExtErrors__OverlayBlocking.bs.js");
var SelectorOverrideWithoutScope$SmartcutsMacros = require("../../../commands/shared/SelectorOverrideWithoutScope.bs.js");
var StateMachine__DebounceManager$SmartcutsMacros = require("../../../StateMachine__DebounceManager.bs.js");
var ExtensionMessaging__FromExtension$SmartcutsMacros = require("../../../ExtensionMessaging__FromExtension.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("../ContentScript__StateMachine__Shared__Types.bs.js");
var ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros = require("../UrlTriggeringMode/ContentScript__StateMachine__UrlTriggeringMode__Types.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* NotSupported */0 :
          return ["NotSupported"];
      case /* TabOrWindowNotVisible */1 :
          return ["TabOrWindowNotVisible"];
      case /* TabOrWindowVisibilityUnknownOrUnloaded */2 :
          return ["TabOrWindowVisibilityUnknownOrUnloaded"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* SearchElementTimedOut */0 :
          return [
                  "SearchElementTimedOut",
                  ExtErrors$SmartcutsMacros.searchElementTimedOut_encode(v._0)
                ];
      case /* QuerySelectorOverridesTimedOut */1 :
          return [
                  "QuerySelectorOverridesTimedOut",
                  Decco.arrayToJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_encode, v._0)
                ];
      case /* CouldNotApplySemantic */2 :
          return [
                  "CouldNotApplySemantic",
                  SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_encode(v._0)
                ];
      case /* OverlayStillBlockingElementAfterMs */3 :
          return [
                  "OverlayStillBlockingElementAfterMs",
                  ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(Decco.stringToJson, v._0)
                ];
      case /* ErrorWhileSearchForElement */4 :
          return [
                  "ErrorWhileSearchForElement",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      case /* ErrorWhileWaitForPossibleOverlayToDisappear */5 :
          return [
                  "ErrorWhileWaitForPossibleOverlayToDisappear",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      case /* RanIntoUnhandledPromiseError */6 :
          return [
                  "RanIntoUnhandledPromiseError",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      
    }
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CouldNotApplySemantic" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CouldNotApplySemantic */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ErrorWhileSearchForElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ErrorWhileSearchForElement */4,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ErrorWhileWaitForPossibleOverlayToDisappear" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */5,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "NotSupported" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotSupported */0
                  };
          }
      case "OverlayStillBlockingElementAfterMs" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OverlayStillBlockingElementAfterMs */3,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "QuerySelectorOverridesTimedOut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.arrayFromJson(SelectorOverrideWithoutScope$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* QuerySelectorOverridesTimedOut */1,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "RanIntoUnhandledPromiseError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RanIntoUnhandledPromiseError */6,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "SearchElementTimedOut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = ExtErrors$SmartcutsMacros.searchElementTimedOut_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SearchElementTimedOut */0,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "TabOrWindowNotVisible" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TabOrWindowNotVisible */1
                  };
          }
      case "TabOrWindowVisibilityUnknownOrUnloaded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TabOrWindowVisibilityUnknownOrUnloaded */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromDomSearchError(error) {
  if (typeof error !== "number") {
    switch (error.TAG | 0) {
      case /* SearchElementTimedOut */7 :
          var match = error._0;
          return {
                  TAG: /* SearchElementTimedOut */0,
                  _0: {
                    selector: match.selector,
                    ms: match.ms
                  }
                };
      case /* QuerySelectorOverridesTimedOut */8 :
          return {
                  TAG: /* QuerySelectorOverridesTimedOut */1,
                  _0: error._0
                };
      case /* ErrorWhileSearchForElement */9 :
          return {
                  TAG: /* ErrorWhileSearchForElement */4,
                  _0: error._0
                };
      
    }
  }
  
}

function fromOverlayError(error) {
  if (typeof error !== "number") {
    if (error.TAG !== /* OverlayStillBlockingElementAfterMs */5) {
      return {
              TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */5,
              _0: error._0
            };
    }
    var match = error._0;
    return {
            TAG: /* OverlayStillBlockingElementAfterMs */3,
            _0: {
              element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
              maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
              ms: match.ms
            }
          };
  }
  
}

function fromDocumentVisibilityError(error) {
  if (typeof error === "number") {
    if (error === /* TabOrWindowNotVisible */2) {
      return /* TabOrWindowNotVisible */1;
    } else {
      return /* TabOrWindowVisibilityUnknownOrUnloaded */2;
    }
  }
  
}

function fromUnhandledError(error) {
  return {
          TAG: /* RanIntoUnhandledPromiseError */6,
          _0: error._0
        };
}

function fromDomSearchOrUnhandledError(error) {
  if (typeof error === "number" || error.TAG !== /* UnhandledContentScriptPromiseError */14) {
    return fromDomSearchError(error);
  } else {
    return fromUnhandledError(error);
  }
}

function fromDomSearchOrOverlayError(error) {
  if (typeof error === "number") {
    return fromDomSearchError(error);
  }
  switch (error.TAG | 0) {
    case /* OverlayStillBlockingElementAfterMs */5 :
    case /* ErrorWhileWaitForPossibleOverlayToDisappear */6 :
        return fromOverlayError(error);
    default:
      return fromDomSearchError(error);
  }
}

function fromDomSearchOrOverlayOrDocumentVisibilityError(error) {
  if (typeof error === "number") {
    switch (error) {
      case /* TabOrWindowNotVisible */2 :
      case /* TabOrWindowVisibilityUnknownOrUnloaded */3 :
          return fromDocumentVisibilityError(error);
      default:
        return fromDomSearchError(error);
    }
  } else {
    switch (error.TAG | 0) {
      case /* OverlayStillBlockingElementAfterMs */5 :
      case /* ErrorWhileWaitForPossibleOverlayToDisappear */6 :
          return fromOverlayError(error);
      default:
        return fromDomSearchError(error);
    }
  }
}

function fromDomSearchOrDocumentVisibilityOrUnhandledError(error) {
  if (typeof error !== "number") {
    if (error.TAG === /* UnhandledContentScriptPromiseError */14) {
      return fromUnhandledError(error);
    } else {
      return fromDomSearchError(error);
    }
  }
  switch (error) {
    case /* TabOrWindowNotVisible */2 :
    case /* TabOrWindowVisibilityUnknownOrUnloaded */3 :
        return fromDocumentVisibilityError(error);
    default:
      return fromDomSearchError(error);
  }
}

function fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error) {
  if (typeof error === "number") {
    switch (error) {
      case /* TabOrWindowNotVisible */2 :
      case /* TabOrWindowVisibilityUnknownOrUnloaded */3 :
          return fromDocumentVisibilityError(error);
      default:
        return fromDomSearchError(error);
    }
  } else {
    switch (error.TAG | 0) {
      case /* OverlayStillBlockingElementAfterMs */5 :
      case /* ErrorWhileWaitForPossibleOverlayToDisappear */6 :
          return fromOverlayError(error);
      case /* UnhandledContentScriptPromiseError */14 :
          return fromUnhandledError(error);
      default:
        return fromDomSearchError(error);
    }
  }
}

function fromSelectionOrCursorSemantics_findInDomAndApplySemanticError(error) {
  if (typeof error === "number") {
    switch (error) {
      case /* TabOrWindowNotVisible */2 :
      case /* TabOrWindowVisibilityUnknownOrUnloaded */3 :
          return fromDocumentVisibilityError(error);
      default:
        return fromDomSearchOrOverlayError(error);
    }
  } else {
    switch (error.TAG | 0) {
      case /* InputSelectionSemanticError */1 :
      case /* InputCursorSemanticError */2 :
      case /* ContentEditableCursorSemanticError */3 :
      case /* ContentEditableSelectionSemanticError */4 :
          return {
                  TAG: /* CouldNotApplySemantic */2,
                  _0: SelectionSemantics$SmartcutsMacros.fromSelectionOrCursorSemanticsError(error)
                };
      default:
        return fromDomSearchOrOverlayError(error);
    }
  }
}

function fromStrictSelectionSemantics_findInDomAndApplySemanticError(error) {
  if (typeof error === "number") {
    return fromDomSearchOrOverlayOrDocumentVisibilityError(error);
  }
  switch (error.TAG | 0) {
    case /* NonInputSelectionSemanticError */0 :
    case /* InputSelectionSemanticError */1 :
        return {
                TAG: /* CouldNotApplySemantic */2,
                _0: SelectionSemantics$SmartcutsMacros.fromStrictSelectionSemanticsError(error)
              };
    default:
      return fromDomSearchOrOverlayOrDocumentVisibilityError(error);
  }
}

function fromInputCursorSemantics_moveCursorAtSelectorError(error) {
  if (typeof error === "number" || error.TAG !== /* InputCursorSemanticError */2) {
    return fromDomSearchOrOverlayOrDocumentVisibilityError(error);
  } else {
    return {
            TAG: /* CouldNotApplySemantic */2,
            _0: error
          };
  }
}

function fromClickInputCommand_execCommandError(error) {
  if (typeof error === "number" || error.TAG !== /* InputCursorSemanticError */2) {
    return fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error);
  } else {
    return {
            TAG: /* CouldNotApplySemantic */2,
            _0: error
          };
  }
}

function fromClickContentEditable_execCommandError(error) {
  if (typeof error === "number" || error.TAG !== /* ContentEditableCursorSemanticError */3) {
    return fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error);
  } else {
    return {
            TAG: /* CouldNotApplySemantic */2,
            _0: error
          };
  }
}

function fromTypeCommand_execCommandError(error) {
  if (typeof error === "number" || error.TAG !== /* InputSelectionSemanticError */1) {
    return fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError(error);
  } else {
    return {
            TAG: /* CouldNotApplySemantic */2,
            _0: {
              TAG: /* InputSelectionSemanticError */1,
              _0: error._0
            }
          };
  }
}

var ReasonNotPlaybackCommand = {
  t_encode: t_encode,
  t_decode: t_decode,
  fromDomSearchError: fromDomSearchError,
  fromOverlayError: fromOverlayError,
  fromDocumentVisibilityError: fromDocumentVisibilityError,
  fromUnhandledError: fromUnhandledError,
  fromDomSearchOrUnhandledError: fromDomSearchOrUnhandledError,
  fromDomSearchOrOverlayError: fromDomSearchOrOverlayError,
  fromDomSearchOrOverlayOrDocumentVisibilityError: fromDomSearchOrOverlayOrDocumentVisibilityError,
  fromDomSearchOrDocumentVisibilityOrUnhandledError: fromDomSearchOrDocumentVisibilityOrUnhandledError,
  fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError: fromDomSearchOrOverlayOrDocumentVisibilityOrUnhandledError,
  fromSelectionOrCursorSemantics_findInDomAndApplySemanticError: fromSelectionOrCursorSemantics_findInDomAndApplySemanticError,
  fromStrictSelectionSemantics_findInDomAndApplySemanticError: fromStrictSelectionSemantics_findInDomAndApplySemanticError,
  fromInputCursorSemantics_moveCursorAtSelectorError: fromInputCursorSemantics_moveCursorAtSelectorError,
  fromClickInputCommand_execCommandError: fromClickInputCommand_execCommandError,
  fromClickContentEditable_execCommandError: fromClickContentEditable_execCommandError,
  fromTypeCommand_execCommandError: fromTypeCommand_execCommandError
};

function t_encode$1(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "triggeringElement",
                ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.triggeringElement_encode(encoder_htmlElement, v.triggeringElement)
              ],
              [
                "respondToBg",
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v.respondToBg)
              ],
              [
                "isPlaybackMode",
                Decco.boolToJson(v.isPlaybackMode)
              ]
            ]);
}

function t_decode$1(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var triggeringElement = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.triggeringElement_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeringElement"), null));
  if (triggeringElement.TAG === /* Ok */0) {
    var respondToBg = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "respondToBg"), null));
    if (respondToBg.TAG === /* Ok */0) {
      var isPlaybackMode = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isPlaybackMode"), null));
      if (isPlaybackMode.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  triggeringElement: triggeringElement._0,
                  respondToBg: respondToBg._0,
                  isPlaybackMode: isPlaybackMode._0
                }
              };
      }
      var e = isPlaybackMode._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".isPlaybackMode" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = respondToBg._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".respondToBg" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = triggeringElement._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".triggeringElement" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var UrlTriggerAfterExit = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(encoder_htmlElement, v) {
  return Js_dict.fromArray([[
                "maybeUrlTriggerAfterExit",
                Decco.optionToJson((function (param) {
                        return t_encode$1(encoder_htmlElement, param);
                      }), v.maybeUrlTriggerAfterExit)
              ]]);
}

function t_decode$2(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var maybeUrlTriggerAfterExit = Decco.optionFromJson((function (param) {
          return t_decode$1(decoder_htmlElement, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict._0, "maybeUrlTriggerAfterExit"), null));
  if (maybeUrlTriggerAfterExit.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              maybeUrlTriggerAfterExit: maybeUrlTriggerAfterExit._0
            }
          };
  }
  var e = maybeUrlTriggerAfterExit._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".maybeUrlTriggerAfterExit" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var Exited = {
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

function mode_encode(encoder_htmlElement, encoder_domEvent, v) {
  if (typeof v === "number") {
    if (v === /* Init */0) {
      return ["Init"];
    } else {
      return ["WaitingForNextCommand"];
    }
  }
  switch (v.TAG | 0) {
    case /* PlayingBackCommand */0 :
        return [
                "PlayingBackCommand",
                Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0)
              ];
    case /* Exiting */1 :
        return [
                "Exiting",
                exiting_encode(encoder_htmlElement, encoder_domEvent, v._0)
              ];
    case /* Exited */2 :
        return [
                "Exited",
                t_encode$2(encoder_htmlElement, v._0)
              ];
    
  }
}

function paginateState_encode(encoder_htmlElement, v) {
  return Js_dict.fromArray([[
                "subtreesWithCollectedDataRecords",
                Decco.arrayToJson(encoder_htmlElement, v.subtreesWithCollectedDataRecords)
              ]]);
}

function playbackWarningModalState_encode(encoder_domEvent, v) {
  if (v) {
    return [
            "ShowingPlaybackWarningModal",
            StateMachine__DebounceManager$SmartcutsMacros.t_encode(encoder_domEvent, Decco.unitToJson, v._0)
          ];
  } else {
    return ["HidingSmartcutsPlaybackWarningModal"];
  }
}

function sideEffect_decode(decoder_htmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AttachListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AttachListeners */0
                  };
          }
      case "ClearDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ClearDebounceTimeout */4,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DetachListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DetachListeners */5
                  };
          }
      case "Dispatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Dispatch */0,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "PlaybackCommandAndRespondToBg" :
          if (tagged.length !== 5) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = PlaybackOptions$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$5 = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 3));
          var match$6 = Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.Playback.respondToSender_decode, Belt_Array.getExn(jsonArr$1, 4));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              if (match$5.TAG === /* Ok */0) {
                if (match$6.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            TAG: /* PlaybackCommandAndRespondToBg */1,
                            _0: match$3._0,
                            _1: match$4._0,
                            _2: match$5._0,
                            _3: match$6._0
                          }
                        };
                }
                var e$3 = match$6._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = match$5._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "RemoveDataExtractionOverlay" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemoveDataExtractionOverlay */4
                  };
          }
      case "RemovePlaybackModal" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemovePlaybackModal */2
                  };
          }
      case "RenderDataExtractionOverlay" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RenderDataExtractionOverlay */3
                  };
          }
      case "RenderPlaybackModal" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RenderPlaybackModal */1
                  };
          }
      case "ResetDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ResetDebounceTimeout */3,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$7 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "RespondToBg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RespondToBg */2,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$9 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function state_decode(decoder_htmlElement, decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var playbackWarningModalState = playbackWarningModalState_decode(decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackWarningModalState"), null));
  if (playbackWarningModalState.TAG === /* Ok */0) {
    var mode = mode_decode(decoder_htmlElement, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mode"), null));
    if (mode.TAG === /* Ok */0) {
      var paginateState = paginateState_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateState"), null));
      if (paginateState.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  playbackWarningModalState: playbackWarningModalState._0,
                  mode: mode._0,
                  paginateState: paginateState._0
                }
              };
      }
      var e = paginateState._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".paginateState" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = mode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".mode" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = playbackWarningModalState._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".playbackWarningModalState" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

function event_decode(decoder_htmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BasicEventWhilePlayback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BasicEventWhilePlayback */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DebounceTimerExpired" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DebounceTimerExpired */5,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DidAttachListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidAttachListeners */1
                  };
          }
      case "DidClearDebounceTimeout" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidClearDebounceTimeout */7,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "DidDetachListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidDetachListeners */3
                  };
          }
      case "DidFinishCollectingDataRecords" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFinishCollectingDataRecords */5
                  };
          }
      case "DidFlushDebouncedEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = StateMachine__DebounceManager$SmartcutsMacros.entry_decode(decoder_domEvent, Decco.unitFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidFlushDebouncedEvent */6,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "DidPlaybackCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidPlaybackCommand */0,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "DidSetNewDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DidSetNewDebounceTimeout */4,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$5 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "DidStartCollectingDataRecords" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidStartCollectingDataRecords */4
                  };
          }
      case "DidntPlaybackCommand" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DidntPlaybackCommand */1,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$7 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "DomEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DomEvent */3,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$9 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = exitReason_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exit */10,
                      _0: v0$5._0
                    }
                  };
          }
          var e$11 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "Fail" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = failure_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Fail */9,
                      _0: v0$6._0
                    }
                  };
          }
          var e$12 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "IgnoreSubtreesWithCollectedDataRecords" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Decco.arrayFromJson(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* IgnoreSubtreesWithCollectedDataRecords */8,
                      _0: v0$7._0
                    }
                  };
          }
          var e$13 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "Initialize" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Initialize */0
                  };
          }
      case "ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function state_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Js_dict.fromArray([
              [
                "playbackWarningModalState",
                playbackWarningModalState_encode(encoder_domEvent, v.playbackWarningModalState)
              ],
              [
                "mode",
                mode_encode(encoder_htmlElement, encoder_domEvent, v.mode)
              ],
              [
                "paginateState",
                paginateState_encode(encoder_htmlElement, v.paginateState)
              ]
            ]);
}

function sideEffect_encode(encoder_htmlElement, encoder_domEvent, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* AttachListeners */0 :
          return ["AttachListeners"];
      case /* RenderPlaybackModal */1 :
          return ["RenderPlaybackModal"];
      case /* RemovePlaybackModal */2 :
          return ["RemovePlaybackModal"];
      case /* RenderDataExtractionOverlay */3 :
          return ["RenderDataExtractionOverlay"];
      case /* RemoveDataExtractionOverlay */4 :
          return ["RemoveDataExtractionOverlay"];
      case /* DetachListeners */5 :
          return ["DetachListeners"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Dispatch */0 :
          return [
                  "Dispatch",
                  event_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      case /* PlaybackCommandAndRespondToBg */1 :
          return [
                  "PlaybackCommandAndRespondToBg",
                  Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0),
                  PlaybackOptions$SmartcutsMacros.t_encode(v._1),
                  Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v._2),
                  Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.Playback.respondToSender_encode, v._3)
                ];
      case /* RespondToBg */2 :
          return [
                  "RespondToBg",
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
      case /* ResetDebounceTimeout */3 :
          return [
                  "ResetDebounceTimeout",
                  Decco.stringToJson(v._0),
                  Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v._1)
                ];
      case /* ClearDebounceTimeout */4 :
          return [
                  "ClearDebounceTimeout",
                  Decco.stringToJson(v._0),
                  DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
      
    }
  }
}

var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

function event_encode(encoder_htmlElement, encoder_domEvent, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* Initialize */0 :
          return ["Initialize"];
      case /* DidAttachListeners */1 :
          return ["DidAttachListeners"];
      case /* ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand */2 :
          return ["ShouldHideSmartcutsPlaybackWarningModalUntilCompletedCommand"];
      case /* DidDetachListeners */3 :
          return ["DidDetachListeners"];
      case /* DidStartCollectingDataRecords */4 :
          return ["DidStartCollectingDataRecords"];
      case /* DidFinishCollectingDataRecords */5 :
          return ["DidFinishCollectingDataRecords"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* DidPlaybackCommand */0 :
          return [
                  "DidPlaybackCommand",
                  Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0)
                ];
      case /* DidntPlaybackCommand */1 :
          return [
                  "DidntPlaybackCommand",
                  Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0),
                  t_encode(v._1)
                ];
      case /* BasicEventWhilePlayback */2 :
          return [
                  "BasicEventWhilePlayback",
                  ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
                ];
      case /* DomEvent */3 :
          return [
                  "DomEvent",
                  Curry._1(encoder_domEvent, v._0),
                  Decco.floatToJson(v._1)
                ];
      case /* DidSetNewDebounceTimeout */4 :
          return [
                  "DidSetNewDebounceTimeout",
                  Decco.stringToJson(v._0),
                  DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
      case /* DebounceTimerExpired */5 :
          return [
                  "DebounceTimerExpired",
                  Decco.stringToJson(v._0)
                ];
      case /* DidFlushDebouncedEvent */6 :
          return [
                  "DidFlushDebouncedEvent",
                  StateMachine__DebounceManager$SmartcutsMacros.entry_encode(encoder_domEvent, Decco.unitToJson, v._0)
                ];
      case /* DidClearDebounceTimeout */7 :
          return [
                  "DidClearDebounceTimeout",
                  Decco.stringToJson(v._0)
                ];
      case /* IgnoreSubtreesWithCollectedDataRecords */8 :
          return [
                  "IgnoreSubtreesWithCollectedDataRecords",
                  Decco.arrayToJson(encoder_htmlElement, v._0)
                ];
      case /* Fail */9 :
          return [
                  "Fail",
                  failure_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      case /* Exit */10 :
          return [
                  "Exit",
                  exitReason_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      
    }
  }
}

function exitReason_decode(decoder_htmlElement, decoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
              }), otherFailureReason_decode, v);
}

function failure_decode(decoder_htmlElement, decoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithoutListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
              }), otherFailureReason_decode, v);
}

function exitReason_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithoutListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
              }), otherFailureReason_encode, v);
}

function failure_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithoutListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
              }), otherFailureReason_encode, v);
}

function exiting_decode(decoder_htmlElement, decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var maybeUrlTriggerAfterExit = Decco.optionFromJson((function (param) {
          return t_decode$1(decoder_htmlElement, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeUrlTriggerAfterExit"), null));
  if (maybeUrlTriggerAfterExit.TAG === /* Ok */0) {
    var didDetachListeners = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didDetachListeners"), null));
    if (didDetachListeners.TAG === /* Ok */0) {
      var nRemainingDebouncedTimeers = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nRemainingDebouncedTimeers"), null));
      if (nRemainingDebouncedTimeers.TAG === /* Ok */0) {
        var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
                return exitReason_decode(decoder_htmlElement, decoder_domEvent, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "allExitReasons"), null));
        if (allExitReasons.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    maybeUrlTriggerAfterExit: maybeUrlTriggerAfterExit._0,
                    didDetachListeners: didDetachListeners._0,
                    nRemainingDebouncedTimeers: nRemainingDebouncedTimeers._0,
                    allExitReasons: allExitReasons._0
                  }
                };
        }
        var e = allExitReasons._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".allExitReasons" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = nRemainingDebouncedTimeers._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".nRemainingDebouncedTimeers" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = didDetachListeners._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".didDetachListeners" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = maybeUrlTriggerAfterExit._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".maybeUrlTriggerAfterExit" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function mode_decode(decoder_htmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Exited" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$2(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exited */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Exiting" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = exiting_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exiting */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Init" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Init */0
                  };
          }
      case "PlayingBackCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PlayingBackCommand */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "WaitingForNextCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* WaitingForNextCommand */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function playbackWarningModalState_decode(decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "HidingSmartcutsPlaybackWarningModal" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* HidingSmartcutsPlaybackWarningModal */0
                  };
          }
      case "ShowingPlaybackWarningModal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = StateMachine__DebounceManager$SmartcutsMacros.t_decode(decoder_domEvent, Decco.unitFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* ShowingPlaybackWarningModal */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function paginateState_decode(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var subtreesWithCollectedDataRecords = Decco.arrayFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict._0, "subtreesWithCollectedDataRecords"), null));
  if (subtreesWithCollectedDataRecords.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              subtreesWithCollectedDataRecords: subtreesWithCollectedDataRecords._0
            }
          };
  }
  var e = subtreesWithCollectedDataRecords._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".subtreesWithCollectedDataRecords" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function exiting_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Js_dict.fromArray([
              [
                "maybeUrlTriggerAfterExit",
                Decco.optionToJson((function (param) {
                        return t_encode$1(encoder_htmlElement, param);
                      }), v.maybeUrlTriggerAfterExit)
              ],
              [
                "didDetachListeners",
                Decco.boolToJson(v.didDetachListeners)
              ],
              [
                "nRemainingDebouncedTimeers",
                Decco.intToJson(v.nRemainingDebouncedTimeers)
              ],
              [
                "allExitReasons",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_htmlElement, encoder_domEvent, param);
                      }), v.allExitReasons)
              ]
            ]);
}

function errorContext_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Curry._4(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithoutListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
              }), v);
}

function errorContext_decode(decoder_htmlElement, decoder_domEvent, v) {
  return Curry._4(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithoutListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
              }), v);
}

function listener_encode(v) {
  return ["NoListener"];
}

function listener_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "NoListener") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* NoListener */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function maybeGetPlaybackModalDebounceManager(playbackWarningModalState) {
  if (playbackWarningModalState) {
    return Caml_option.some(playbackWarningModalState._0);
  }
  
}

var Generic = {
  UrlTriggerAfterExit: UrlTriggerAfterExit,
  Exited: Exited,
  mode_encode: mode_encode,
  mode_decode: mode_decode,
  state_encode: state_encode,
  state_decode: state_decode,
  paginateState_encode: paginateState_encode,
  paginateState_decode: paginateState_decode,
  playbackWarningModalState_encode: playbackWarningModalState_encode,
  playbackWarningModalState_decode: playbackWarningModalState_decode,
  exiting_encode: exiting_encode,
  exiting_decode: exiting_decode,
  event_encode: event_encode,
  event_decode: event_decode,
  failure_encode: failure_encode,
  failure_decode: failure_decode,
  exitReason_encode: exitReason_encode,
  exitReason_decode: exitReason_decode,
  errorContext_encode: errorContext_encode,
  errorContext_decode: errorContext_decode,
  otherFailureReason_encode: otherFailureReason_encode,
  otherFailureReason_decode: otherFailureReason_decode,
  sideEffect_encode: sideEffect_encode,
  sideEffect_decode: sideEffect_decode,
  listener_encode: listener_encode,
  listener_decode: listener_decode,
  maybeGetPlaybackModalDebounceManager: maybeGetPlaybackModalDebounceManager
};

var Regular = {};

var ForSerialization = {};

exports.ReasonNotPlaybackCommand = ReasonNotPlaybackCommand;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization;
/* ExtErrors-SmartcutsMacros Not a pure module */
